export default __webpack_public_path__ + "static/media/add-item.78394d53.png";